import React, { useState, useEffect } from 'react'
import { Page } from '../../ui/Page/Page'
import { useTranslation } from 'react-i18next'
import { Spinner } from '../../ui'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'
import cn from 'classnames'
import { getFundName } from '../api'
import { InvestorAccountForm } from './InvestorAccountForm/InvestorAccountForm'
import styles from './style.css'

const CreateInvestorAccount = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const { fundId = '' } = queryString.parse(location.search)
  const [isFundNameLoading, setIsFundNameLoading] = useState(true)
  const [fundName, setFundName] = useState('')
  const [fundNameError, setFundNameError] = useState('')

  useEffect(() => {
    const resolve = ({ name }) => {
      setIsFundNameLoading(false)
      setFundName(name)
    }
    const reject = ({ message }) => {
      setIsFundNameLoading(false)
      setFundNameError(message)
    }
    if (fundId.length) {
      getFundName(fundId).then(resolve, reject)
    }
  }, [fundId])

  const isFundIdExists = fundId.length > 0 && !fundNameError.length

  return (
    <Page caption={t('createInvestorAccount.createAccount')}>
      {!fundId.length && (
        <div className={cn(styles.fundIdError, styles.error)}>
          {t('createInvestorAccount.invalidLink')}
        </div>)}
      {fundNameError.length > 0 && (
        <div className={cn(styles.fundIdError, styles.error)}>
          {fundNameError}
        </div>)}
      {isFundIdExists && !isFundNameLoading && (
        <InvestorAccountForm fundId={fundId} fundName={fundName} />
      )}
      {isFundNameLoading && fundId.length > 0 && <Spinner />}
    </Page>
  )
}

export { CreateInvestorAccount }
